// extracted by mini-css-extract-plugin
module.exports = {"CheckList":"CheckList-module__CheckList___X_VPG","marker":"CheckList-module__marker___2nlFZ","item":"CheckList-module__item___3fmMY","big":"CheckList-module__big___3MEzg"};